var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonDeduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h434.79v473.58h-434.79z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h473.58v428.79h-473.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 184h473.58v428.79h-473.58z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h426.79v473.58h-426.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h382.79v473.58h-382.79z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h434.79v473.58h-434.79z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h473.58v428.79h-473.58z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 139.21h473.58v428.79h-473.58z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m186 139.21h426.79v473.58h-426.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230 139.21h382.79v473.58h-382.79z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m178 139.21h434.79v473.58h-434.79z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.21 184h473.58v428.79h-473.58z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69.859 -82.075)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.23929 0 0 .23929 62.649 81.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.304 2.8542c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5c0.3 0 0.60039-0.099219 0.90039-0.19922l1.1992 1.1992-1.1992 1.1992c-0.3-0.1-0.60039-0.19922-0.90039-0.19922-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5c0-0.3-0.09922-0.7-0.19922-1l1.0996-1.0996 3.4004 3.5996h2.6992l-7.1992-7.5c0.1-0.3 0.19922-0.7 0.19922-1 0-1.4-1.1-2.5-2.5-2.5zm6.8008 1-2.7012 2.9004 1.3008 1.4004 4.0996-4.3008zm-6.8008 0.5c0.5 0 1 0.5 1 1s-0.5 1-1 1-1-0.5-1-1 0.5-1 1-1zm3.3066 4.1875c0.173 0 0.3125 0.1395 0.3125 0.3125s-0.13855 0.3125-0.31055 0.3125c-0.173 0-0.31445-0.1395-0.31445-0.3125s0.1405-0.3115 0.3125-0.3125zm-3.3066 2.8125c0.5 0 1 0.5 1 1s-0.5 1-1 1-1-0.5-1-1 0.5-1 1-1z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.012165 0 0 .012165 68.604 81.234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.034 0 0 1.034 -9.5397 -53.407)",
    strokeMiterlimit: 10,
    strokeWidth: 79.502
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9713 20.914)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.7 477.4-36.933 22.373 39.303 64.891h86.066v-43.179h-61.734z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9713 20.914)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.62 375.85-36.314 23.361 29.992 46.629 36.314-23.361z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9713 20.914)",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m406.08 187.34v43.179h54.96l26.685 43.632 36.833-22.532-39.32-64.279z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9713 20.914)",
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m554.56 302.37-38.038 20.43 28.485 53.034-26.241 47.332 37.762 20.941 37.662-67.938z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.9713 20.914)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m491.01 473.96-29.808 47.525h-55.647v43.179h79.535l42.501-67.754z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonDeduction);
export default __webpack_public_path__ + "static/media/polygon-deduction.828849d1.svg";
export { ForwardRef as ReactComponent };